import { logEvent } from "./logging";

let bound = false;

export function initMonitoring() {
  if (bound) return;
  bound = true;
  try {
    window.addEventListener("error", (e) => {
      try {
        logEvent("client:error", {
          message: e.message,
          source: (e as any).filename,
          lineno: (e as any).lineno,
          colno: (e as any).colno,
          stack: (e.error as any)?.stack,
        });
      } catch {
        /* noop */
      }
    });
    window.addEventListener("unhandledrejection", (e) => {
      try {
        const reason: any = (e as any).reason;
        logEvent("client:unhandledrejection", {
          message: reason?.message || String(reason),
          stack: reason?.stack,
        });
      } catch {
        /* noop */
      }
    });
  } catch {
    /* noop */
  }
}
